import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
const RankPortalList: React.FC<{
  listItems: any[];
  backgroundColor: string;
  title: string;
  height: string;
}> = ({ listItems = [], backgroundColor = '', title = '', height = '' }) => {
  return (
    <div
      style={{
        margin: '5px 10px',
        padding: '20px 30px',
        fontSize: '20px',
        borderRadius: '50px',
        overflowWrap: 'anywhere',
        width: 280,
        height: `${parseFloat(height) ? parseFloat(height) + 'px' : 'auto'}`,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: backgroundColor ? backgroundColor : '#ccc',
      }}
      className="rank-portal-list-container"
    >
      <div
        className="rank-portal-list-title"
        style={{
          textAlign: 'center',
          color: '#115293',
          fontSize: 24,
          fontWeight: 400,
          marginBottom: 10,
        }}
      >
        {title}
      </div>
      {listItems.length ? (
        <div className="rank-portal-list">
          {listItems.map((item) => {
            return (
              <div className="flex ai-center" style={{ margin: '10px 0' }}>
                <FaCheckCircle size={20} color={'#115293'} />
                <div
                  className="rank-portal-list-item-text"
                  style={{ marginLeft: 10, fontSize: 16 }}
                >
                  {item.listItemText}
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default RankPortalList;
